import axios from 'axios';

export default axios.create({
  headers: { 
    'Content-Type': 'multipart/form-data',
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-TOKEN': document.head.querySelector("meta[name=\"csrf-token\"]").getAttribute("content"),
    'X-Timezone': Intl && Intl.DateTimeFormat().resolvedOptions().timeZone,
  }
});